import { Directive, Renderer2, AfterViewInit, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatTabGroup } from '@angular/material/tabs';

const getTabIndex = MatTabGroup.prototype._getTabIndex;
MatTabGroup.prototype._getTabIndex = function (...args: unknown[]): number {
  const res = getTabIndex.apply(this, args);
  return res === -1 ? 0 : res; // Ensure tab index is not -1
};

@Directive({
  selector: '[libMatTabsGroupsAccessibility]',
  standalone: true,
})
export class MatTabsGroupsAccessibilityDirective implements AfterViewInit {
  readonly destroyRef = inject(DestroyRef);
  readonly tabGroup = inject(MatTabGroup);
  readonly renderer = inject(Renderer2);

  ngAfterViewInit(): void {
    this.removeTabsNavigationParams();
    this.removeTabsListRole();
    this.removeMatFocusIndicator();

    this.tabGroup.selectedTabChange.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
      this.removeTabsNavigationParams();
      this.removeMatFocusIndicator();
    });
  }

  private removeTabsNavigationParams(): void {
    const tabs = this.tabGroup._elementRef.nativeElement.querySelectorAll('.mat-mdc-tab');
    tabs.forEach((tab: HTMLElement) => {
      this.renderer.removeAttribute(tab, 'tabindex');
      this.renderer.removeAttribute(tab, 'role');
    });
  }

  private removeTabsListRole(): void {
    const tabsList = this.tabGroup._elementRef.nativeElement.querySelector('.mat-mdc-tab-list');
    this.renderer.removeAttribute(tabsList, 'role');
  }

  private removeMatFocusIndicator(): void {
    const indicators = this.tabGroup._elementRef.nativeElement.querySelectorAll('.mat-mdc-focus-indicator');
    indicators.forEach((indicator: HTMLElement) => {
      this.renderer.removeAttribute(indicator, 'aria-setsize');
      this.renderer.removeAttribute(indicator, 'aria-posinset');
      this.renderer.removeAttribute(indicator, 'aria-selected');
    });
  }
}
